import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TuiProgressModule } from "@taiga-ui/kit";
import { KwikUIProgressSegmentedComponent } from "./progress-segmented.component";

@NgModule({
  declarations: [KwikUIProgressSegmentedComponent],
  imports: [CommonModule, TuiProgressModule],
  exports: [KwikUIProgressSegmentedComponent]
})
export class KwikUIProgressSegmentedModule {}
